import {createContext} from 'react'

export const FloatContainerContext = createContext()

export const TabsWrapperContext = createContext()

export const GlobalContext = createContext()
